import { Text } from 'blaze-ui/Text/Text'
import Styles from './Tooltip.module.scss'
import dayjs from 'dayjs'
import { Heading } from 'blaze-ui/Heading/Heading'
import cx from 'classnames'

export type TooltipVariant = 'default' | 'compact'

interface Props {
  name: string
  x: number
  y: number
  value: { date: Date; value: number | string } | null
  variant?: TooltipVariant
}

export const Tooltip = ({ name, x, y, value, variant = 'default' }: Props) => {
  if (!value) {
    return null
  }

  return (
    <div className={cx(Styles.tooltip, Styles[variant])} style={{ left: x, top: y }}>
      <Text variant={variant === 'default' ? 'metadata' : 'smallList'}>{dayjs(value.date).format('ddd, MMM D')}</Text>
      <div className={Styles.value}>
        <Heading level={4}>{value.value}</Heading>
        {variant === 'default' && (
          <Text variant="metadata" color="var(--dark-40)">
            {name}
          </Text>
        )}
      </div>
    </div>
  )
}
